// material-ui
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

// styles
const LoaderWrapper = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1224,
});

// ==============================|| LOADER ||============================== //
const BlockingLoader = ({isLoading, text}) => (
    <>
       { isLoading && 
       <LoaderWrapper>
            <Box sx={{ position: 'sticky', display: 'flex', top: 0, left: 0, right: 0, height: "100vh", flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(255,255,255, 0.8)'}}>
                <CircularProgress disableShrink style={{ marginBottom: '20px' }} />
                <Typography color="textPrimary" variant="bold" >{!!text ? text : 'Loading...'}</Typography>
            </Box>
        </LoaderWrapper> }
    </>
);

export default BlockingLoader;
